<template>
  <div class="box" style="padding-top: 40rpx;">
    <div v-for="item in list" :key="item.id">
      <div class="text-box">
        <div class="sub-item space-box">
          <div class="sub-color" style="color: #fff;font-size: 32rpx;font-weight: 700;">{{numberToChinese(item)}}</div>
        </div>
        <div class="sub-item space-box">
          <div class="sub-color">许可时间</div>
          <div class="">{{item.sellTime}}</div>
        </div>
        <div class="sub-item space-box">
          <div class="sub-color">许可量</div>
          <div class="">{{item.totalCount}}枚</div>
        </div>
        <div class="sub-item space-box">
          <div class="sub-color">许可编号</div>
          <div class="">{{number(item)}}</div>
        </div> 
        <div class="sub-item space-box">
          <div class="sub-color">许可价</div>
          <div class="">{{item.price}}元</div>
        </div>
        <div class="sub-item space-box">
          <div class="sub-color">已许可</div>
          <div class="">{{accSubtract(item.totalCount, item.remainingCount)}}枚</div>
        </div>
        <div class="sub-item space-box">
          <div class="sub-color">作品状态</div>
          <div :class="item.remainingCount > 0 ? 'buy-btn' : 'buy-none'">{{item.remainingCount > 0 ? '可持有' : '已售罄'}}</div>
        </div>
      </div>
    </div>
  </div>	
</template>

<script>
  import { intToChinese } from '../../../help/utils'
  import { accSubtract } from '../../../help/calculate'
	export default {
    props: {
      list: {
        type:Array,
        default: () => []
      }
    },
		data() {
			return {
        accSubtract
			}
		},
    methods: {
      numberToChinese (item) {
        if(item.batchCount === 1){
          return '首批许可'
        }
        return `第${intToChinese(item.batchCount)}批许可`
      },
      number (item) {
        if (item.endNumber == 1) return '#1'
        return `#${item.startNumber}-#${item.endNumber}`
      }
    }
	}
</script>

<style lang="scss" scoped>
	.box{
		padding-bottom: 50px;
	}
	.text-box{
		width: 100%;
		height: 320px;
		padding: 10px 0;
		background-color: #21262A;
		margin: 0 auto 20px;
		border-radius: 8px;
		position: relative;
		z-index: 9;
	}
	.sub-item{
		width: calc(100% - 30px);
		height: 43px;
		border-radius: 8px;
		margin: 0 auto;
		position: relative;
		color: #A5AFB1;
	}
	.buy-btn{
		width: 60px;
		height: 25px;
		color: white;
		border-radius: 50px;
		line-height: 25px;
		text-align: center;
		background-image: linear-gradient(to right,#18D9E9,#0FE633);
	}
	.buy-none{
		width: 60px;
		height: 25px;
		color: white;
		border-radius: 50px;
		line-height: 25px;
		text-align: center;
		background: #A5AFB1;
	}
  .space-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .star-box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .item{
    width: 100%;
    height: 50px;
    color: $sub-font-color;
    margin-top: 10px;
    border-radius: 8px;
    padding: 15px;
  }
  .column-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>